// extracted by mini-css-extract-plugin
export var new_letter__container = "index-module--new_letter__container--725e8";
export var security_desc = "index-module--security_desc--4ae7f";
export var security_new_letter = "index-module--security_new_letter--8c50a";
export var security_switch_btn_container = "index-module--security_switch_btn_container--04a89";